import React, {  useEffect , useRef, useLayoutEffect } from "react";
import {RunSliderDots} from "./slider-dots-run";
import {ISliderDots} from "./interfaces";
import {isMobile, isTablet} from "../../../domain/common";


interface ISliderDotsProps {
    sliderDots:ISliderDots [],
    cnt:number,
    dataHeight:number | null,
    dataHeightTablet: number | null,
    dataHeightIphone: number | null,
    dataBG:string| null,
    dataStyle:string,
    autoScroll: number | null | undefined
}
/**
 * the entry point
 */
const SliderDots = (props?: ISliderDotsProps) => {

    const ImageCDNDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase()
    const dataHeight = props?.dataHeight != null ? props?.dataHeight : 500;
    const dataHeightIphone = props?.dataHeightIphone != null ? props?.dataHeightIphone : 200;
    const dataHeightTablet = props?.dataHeightTablet != null ? props?.dataHeightTablet : 350;
    const dataBG = props?.dataBG != null ? props?.dataBG : '#FFFFFF';
    const dataStyle = props?.dataStyle;

    /*Calc styles*/
    const isWhiteBG = (dataBG ===  '#FFFFFF');
    let dataHeightCalc =  isMobile()
        ? dataHeightIphone
        : isTablet()
            ? dataHeightTablet
            : dataHeight;
    //console.log('dataHeightCalc: ' +  isTablet().toString(),dataHeightCalc);

    const firstDetect = useRef(true);
    useLayoutEffect(() => {
        const elSlider = document.getElementById("slider-dot-" + props?.cnt);
        const elSliderContent = document.getElementById("slider-dot-content-" + props?.cnt);
        if (firstDetect.current) {

            if(elSlider && elSliderContent){
                //console.log('elSliderContent: ',elSliderContent);
                RunSliderDots(elSlider,props?.autoScroll);
                firstDetect.current = false;
            }
            return;
        }

    })


    useEffect(() => {
    }, []);





    return (
        <>
            <div id={"slider-dot-content-" + props?.cnt} className={`${dataStyle} slider max-w-full`}>
                <div className="imgs flex items-center" style={{height:isWhiteBG ? ((dataHeightCalc) + 'px') : ((dataHeightCalc + 64) + 'px'), background: isWhiteBG ? '' : dataBG, padding: isWhiteBG ? '0' :'2rem 0' }}>
                    {
                        props?.sliderDots && props?.sliderDots.map((item, i) => {
                            // const bgImage = "url(\""+ImageCDNDomain+item.imgpath + "?max-h="+150+"&max-w=800"+"\")";
                            let bgImage = `url(${ ImageCDNDomain }${ item.imgpath }?max-h=150&max-w=800)`;
                            if(isMobile() && item.imgmobile) {
                                bgImage = `url(${ImageCDNDomain}${decodeURIComponent(item.imgmobile)}`;
                            }
                            if(isTablet() && item.imgtablet) {
                                bgImage = `url(${ImageCDNDomain}${decodeURIComponent(item.imgtablet)}`;
                            }

                            return (
                                <div key={props.cnt + '-' + i} className="img relative" >
                                    <div className="img-cont" style={{background:bgImage, height:dataHeightCalc + 'px'}}></div>
                                    {dataStyle === 'style-1' && item.text_1 && <div className="abs-cont flex flex-col">
                                        <div className="text-1" dangerouslySetInnerHTML={{ __html: item.text_1 }}></div>
                                        <div className="text-2" dangerouslySetInnerHTML={{ __html: item.text_2 }}></div>
                                    </div>
                                    }

                                    {dataStyle === 'style-2' && item.text_1 && <div className="abs-cont flex flex-col pr-4">
                                        <div className="text-3" dangerouslySetInnerHTML={{__html: item.text_3}}></div>
                                        <div className="text-2" dangerouslySetInnerHTML={{__html: item.text_2}}></div>
                                        <div className="text-1" dangerouslySetInnerHTML={{__html: item.text_1}}></div>
                                    </div>
                                    }
                                    {dataStyle === 'style-2' && item.text_badge && <div className="abs-text-badge">
                                        <div className="text-badge" dangerouslySetInnerHTML={{__html: item.text_badge}}></div>
                                    </div>
                                    }
                                </div>
                            )

                        })
                    }

                </div>
                <div className="dots"></div>
            </div>
        </>
    )


};

export default SliderDots;
